import React from 'react';
import { Helmet } from 'react-helmet';
import {
  ASSESSMENT_CATEGORIES,
  ASSESSMENTS_CTA,
  ASSESSMENTS_INTRO,
  ASSESSMENTS_META,
  ASSESSMENTS_SECTIONS,
  BESPOKE_PROFILES,
  SELECTION_STEPS,
  TWO_PATHS,
} from '../content/assessments';
import { COMPANY } from '../content/company';
import Reveal from '../primitives/Reveal';
import ClosingCta from '../sections/ClosingCta';
import Hero from '../sections/Hero';
import HowItWorks from '../sections/HowItWorks';
import IntroStatement from '../sections/IntroStatement';
import NumberedSection from '../sections/NumberedSection';
import ProfileLibrary from '../sections/ProfileLibrary';

/**
 * /assessments, on the same shell as the other hero pages (owner, 2026-09-15:
 * "follow the format from the others"). Breadth without a laboratory
 * catalogue: two equal routes in, the profile library by category, bespoke
 * profiles, the connected process, and a call to discuss rather than buy.
 */
export default function AssessmentsPage() {
  return (
    <>
      <Helmet>
        <title>{ASSESSMENTS_META.title}</title>
        <meta name="description" content={ASSESSMENTS_META.description} />
        <link rel="canonical" href={`${COMPANY.siteUrl}/assessments`} />
      </Helmet>

      <Hero image="hero-assessments" />
      <IntroStatement eyebrow={ASSESSMENTS_INTRO.eyebrow} statement={ASSESSMENTS_INTRO.heading} body={ASSESSMENTS_INTRO.body} />

      <NumberedSection id="two-paths" numeral={ASSESSMENTS_SECTIONS.paths.numeral} title={ASSESSMENTS_SECTIONS.paths.title}>
        <Reveal>
          <p className="mk-paths__frame t-body">{TWO_PATHS.framing}</p>
          <div className="mk-paths">
            {TWO_PATHS.paths.map((path) => (
              <div key={path.id} className="mk-paths__item">
                <h3 className="mk-paths__title">{path.title}</h3>
                <p className="mk-paths__body t-body">{path.body}</p>
              </div>
            ))}
          </div>
          <p className="mk-paths__note t-body">{TWO_PATHS.qualifier}</p>
        </Reveal>
      </NumberedSection>

      <NumberedSection id="profile-library" numeral={ASSESSMENTS_SECTIONS.library.numeral} title={ASSESSMENTS_SECTIONS.library.title}>
        <ProfileLibrary categories={ASSESSMENT_CATEGORIES} />
      </NumberedSection>

      <NumberedSection id="bespoke" numeral={ASSESSMENTS_SECTIONS.bespoke.numeral} title={ASSESSMENTS_SECTIONS.bespoke.title}>
        <Reveal>
          <div className="mk-prose t-body">
            {BESPOKE_PROFILES.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        </Reveal>
      </NumberedSection>

      <NumberedSection id="selection" numeral={ASSESSMENTS_SECTIONS.process.numeral} title={ASSESSMENTS_SECTIONS.process.title}>
        <HowItWorks steps={SELECTION_STEPS} />
      </NumberedSection>

      <ClosingCta
        image="closing-window-coast"
        title={ASSESSMENTS_CTA.title}
        body={ASSESSMENTS_CTA.body}
        action={{ label: ASSESSMENTS_CTA.action.label, href: `mailto:${COMPANY.email}` }}
      />
    </>
  );
}
